import { memo, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { View } from "../../Base";
import { PickupPopup } from "../../SearchBar/PickupPopup";
import { EditPickupPartnerColumn } from "./EditPickupPartnerColumn";

const useStyles = makeStyles({
  rowContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: "0.7rem",
    gap: "1rem",
  },
  columnContainer: {
    height: "1.6rem",
    display: "flex",
  },
  labelContainer: {
    width: "10rem",
    textAlign: "right",
    margin: "0.1rem 1rem 0rem 0rem",
  },
});

export const EditPickupPartnerRow = memo(
  ({ label, deliveryColumn, collectionColumn, routeEdit, onEdit }) => {
    const styles = useStyles();
    const [deliveryAnchorEl, setDeliveryAnchorEl] = useState();
    const [collectionAnchorEl, setCollectionAnchorEl] = useState();

    return (
      <View>
        <View className={styles.rowContainer}>
          <View className={styles.columnContainer}>
            <View className={styles.labelContainer}>{`${label}:`}</View>
          </View>

          <EditPickupPartnerColumn
            anchorEl={deliveryAnchorEl}
            setAnchorEl={setDeliveryAnchorEl}
            routeEdit={routeEdit}
            onEdit={() => {
              onEdit(deliveryColumn.key);
            }}
            value={deliveryColumn.value}
            {...deliveryColumn.config}
          />

          <EditPickupPartnerColumn
            anchorEl={collectionAnchorEl}
            setAnchorEl={setCollectionAnchorEl}
            routeEdit={routeEdit}
            onEdit={() => {
              onEdit(collectionColumn.key);
            }}
            value={collectionColumn.value}
            {...collectionColumn.config}
          />
        </View>
        <PickupPopup
          anchorEl={deliveryAnchorEl}
          pickupConfig={deliveryColumn.config}
          onClose={() => setDeliveryAnchorEl(null)}
        />
        <PickupPopup
          anchorEl={collectionAnchorEl}
          pickupConfig={collectionColumn.config}
          onClose={() => setCollectionAnchorEl(null)}
        />
      </View>
    );
  }
);
